function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alert",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 41.08 38.52 63.32 18.06 5.36 0 41.08",
    style: {
      fill: "#f4544d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "27.15 0 18.06 5.36 38.52 63.32 47.61 57.96 27.15 0",
    style: {
      fill: "#ff9a83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "20.36 42.09 20.36 47.47 15.4 44.82 15.4 39.45 20.36 42.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "15.02 34.46 16.12 36.55 19.09 38.09 20.33 37.09 20.33 23.17 15.02 20.45 15.02 34.46",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.513de4c4a4e86f9fafd7d83d01915b0b.svg";
export { ForwardRef as ReactComponent };